var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystoreWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "playstore_white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194.4,
    height: 67.4,
    viewBox: "0 0 194.4 67.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.053,
    y1: 104.274,
    x2: -0.25,
    y2: 104.944,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.246,
    y1: 305.953,
    x2: -1.124,
    y2: 305.953,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.969,
    y1: 203.633,
    x2: -0.396,
    y2: 205.408,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.079,
    y1: 202.389,
    x2: 0.528,
    y2: 203.179,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M7.7,0h179a7.7,7.7,0,0,1,7.7,7.7v52a7.7,7.7,0,0,1-7.7,7.7H7.7A7.7,7.7,0,0,1,0,59.7V7.7A7.64,7.64,0,0,1,7.7,0Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M69.91,21.4a3.541,3.541,0,0,1-1,2.6,3.361,3.361,0,0,1-2.8,1.1,4.058,4.058,0,0,1-4-4.2,3.631,3.631,0,0,1,1.2-2.8,3.784,3.784,0,0,1,2.8-1.2,4.529,4.529,0,0,1,1.6.3,2.55,2.55,0,0,1,1.2.9l-.7.8a2.2,2.2,0,0,0-2.1-.9,3.294,3.294,0,0,0-3.1,3.3,2.878,2.878,0,0,0,.9,2.1,3.018,3.018,0,0,0,4.3,0,2.33,2.33,0,0,0,.7-1.5h-2.8V21h3.7C69.91,21.1,69.91,21.2,69.91,21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M75.91,18.2h-3.5v2.5h3.2v1h-3.2v2.5h3.5v1h-4.6V17.4h4.5v.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M80.11,25h-1V18.2h-2.2v-1h5.4v1h-2.2V25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M86.11,25V17.2h1V25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M91.51,25h-1V18.2h-2.2v-1h5.4v1h-2.2V25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M103.81,24a4.172,4.172,0,0,1-5.7,0,4.3,4.3,0,0,1,0-5.8,4.172,4.172,0,0,1,5.7,0h0A4.3,4.3,0,0,1,103.81,24Zm-5-.6a2.9,2.9,0,0,0,4.2,0,3.262,3.262,0,0,0,0-4.5,2.9,2.9,0,0,0-4.2,0,3.481,3.481,0,0,0,0,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M106.31,25V17.2h1.2l3.7,6h0v-6h1V25h-1.1l-3.9-6.3h0V25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M96.71,36.3a5.5,5.5,0,1,0,5.5,5.5A5.616,5.616,0,0,0,96.71,36.3Zm0,8.8a3.429,3.429,0,0,1-3.6-3.1,3.482,3.482,0,0,1,3.1-3.6,3.429,3.429,0,0,1,3.6,3.1v.3a3.224,3.224,0,0,1-3.1,3.3Zm-12-8.8a5.5,5.5,0,1,0,5.5,5.5A5.616,5.616,0,0,0,84.71,36.3Zm0,8.8a3.429,3.429,0,0,1-3.6-3.1,3.482,3.482,0,0,1,3.1-3.6,3.429,3.429,0,0,1,3.6,3.1v.3a3.294,3.294,0,0,1-3.1,3.3ZM70.31,38v2.3h5.6a5.07,5.07,0,0,1-1.3,3,5.727,5.727,0,0,1-4.3,1.7,6.207,6.207,0,0,1,0-12.4,5.973,5.973,0,0,1,4.2,1.6l1.6-1.6a7.916,7.916,0,0,0-5.8-2.3,8.5,8.5,0,0,0,0,17h0a7.7,7.7,0,0,0,5.9-2.4,7.519,7.519,0,0,0,2-5.5,6.6,6.6,0,0,0-.1-1.4Zm58.5,1.8a5.047,5.047,0,0,0-4.7-3.5,5.143,5.143,0,0,0-5.1,5.2v.2a5.362,5.362,0,0,0,5.2,5.5h.2a5.465,5.465,0,0,0,4.6-2.4l-1.9-1.2a3.04,3.04,0,0,1-5.3-.1l7.4-3Zm-7.4,1.8a3.083,3.083,0,0,1,2.8-3.2h0a2.09,2.09,0,0,1,2.1,1.1Zm-6,5.4h2.4V30.8h-2.4Zm-4-9.4h0a4.41,4.41,0,0,0-3-1.2,5.5,5.5,0,0,0,0,11,4.234,4.234,0,0,0,3-1.2h.1V47c0,2.1-1.1,3.3-3,3.3a2.882,2.882,0,0,1-2.7-2l-2.1.9a5.224,5.224,0,0,0,4.9,3.3c2.8,0,5.2-1.6,5.2-5.7V37h-2.3l-.1.6Zm-2.7,7.7a3.314,3.314,0,0,1,0-6.6,3.138,3.138,0,0,1,3.1,3.2V42a3.1,3.1,0,0,1-2.8,3.3q-.3-.3-.3,0Zm31.5-14.5h-5.8V47h2.4V40.9h3.4a5.1,5.1,0,0,0,5.5-4.5,4.974,4.974,0,0,0-4.5-5.5A3.4,3.4,0,0,0,140.21,30.8Zm.1,7.8h-3.4V33h3.4a2.8,2.8,0,1,1,0,5.6Zm14.9-2.3a4.651,4.651,0,0,0-4.3,2.5l2.2.9a2.4,2.4,0,0,1,2.2-1.2,2.273,2.273,0,0,1,2.5,2.1h0v.1a5.528,5.528,0,0,0-2.5-.7c-2.3,0-4.7,1.3-4.7,3.6a3.694,3.694,0,0,0,3.9,3.5h.1a3.5,3.5,0,0,0,3.1-1.5h.1v1.2h2.3v-6C160.11,37.9,157.91,36.3,155.21,36.3Zm-.4,8.8c-.8,0-1.9-.4-1.9-1.4,0-1.2,1.4-1.7,2.5-1.7a5.45,5.45,0,0,1,2.2.5,2.576,2.576,0,0,1-2.8,2.6Zm13.7-8.5-2.7,7h-.1l-2.8-7h-2.6l4.3,9.8-2.4,5.5h2.5l6.7-15.2-2.9-.1ZM146.91,47h2.4V30.8h-2.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M23.51,19.3a2.155,2.155,0,0,0-.5,1.7V47.1a3.371,3.371,0,0,0,.5,1.7l.1.1,14.6-14.7v-.3L23.51,19.3Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M43.11,39.1l-4.9-4.9v-.3l4.9-4.9.1.1,5.8,3.3c1.7.9,1.7,2.5,0,3.4L43.21,39Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M43.21,39.1l-5-5L23.51,48.8a2.1,2.1,0,0,0,2.5.1l17.2-9.8",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M43.21,29.1l-17.3-9.9a1.965,1.965,0,0,0-2.5.1L38.11,34Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M43.11,39l-17.2,9.8a2.107,2.107,0,0,1-2.4,0h0l.1.1h0a2.107,2.107,0,0,0,2.4,0l17.3-9.8Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M23.51,48.6a2.155,2.155,0,0,1-.5-1.7v.2a3.371,3.371,0,0,0,.5,1.7v-.2Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M49.01,35.6l-5.9,3.3.1.1,5.8-3.4a1.712,1.712,0,0,0,1.2-1.6h0A2.2,2.2,0,0,1,49.01,35.6Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M26.01,19.4l23,13.1a2.235,2.235,0,0,1,1.2,1.5h0a2,2,0,0,0-1.2-1.7l-23-13.1c-1.6-.9-3-.2-3,1.7V21C23.01,19.3,24.31,18.5,26.01,19.4Z",
    fill: "#fff",
    opacity: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreWhite);
export default __webpack_public_path__ + "static/media/playstore_white.7271644302e3d2d73f232877e181cbe3.svg";
export { ForwardRef as ReactComponent };